/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // Update cart attributes based on line item metafields
  function updateCartAttributes() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const attributes = {};
        let hasChanges = false;

        // Check for dangerous goods
        const hasDangerousGoods = cart.items.some((item) => {
          const has =
            item.properties && item.properties._exo_dangerous_goods === 'true';
          return has;
        });
        if (hasDangerousGoods && !cart.attributes._exo_dangerous_goods) {
          attributes._exo_dangerous_goods = 'true';
          hasChanges = true;
        } else if (!hasDangerousGoods && cart.attributes._exo_dangerous_goods) {
          attributes._exo_dangerous_goods = '';
          hasChanges = true;
        }

        // Check for bulky goods
        const hasBulkyGoods = cart.items.some((item) => {
          const has =
            item.properties && item.properties._exo_bulky_goods === 'true';
          return has;
        });
        if (hasBulkyGoods && !cart.attributes._exo_bulky_goods) {
          attributes._exo_bulky_goods = 'true';
          hasChanges = true;
        } else if (!hasBulkyGoods && cart.attributes._exo_bulky_goods) {
          attributes._exo_bulky_goods = '';
          hasChanges = true;
        }

        // Check for online only
        const hasOnlineOnly = cart.items.some((item) => {
          const has =
            item.properties && item.properties._exo_online_only === 'true';
          return has;
        });
        if (hasOnlineOnly && !cart.attributes._exo_online_only) {
          attributes._exo_online_only = 'true';
          hasChanges = true;
        } else if (!hasOnlineOnly && cart.attributes._exo_online_only) {
          attributes._exo_online_only = '';
          hasChanges = true;
        }

        // Check for pre order
        const hasPreOrder = cart.items.some((item) => {
          const has =
            item.properties && item.properties._pre_order === 'true';
          return has;
        });
        if (hasPreOrder && !cart.attributes._pre_order) {
          attributes._pre_order = 'true';
          hasChanges = true;
        } else if (!hasPreOrder && cart.attributes._pre_order) {
          attributes._pre_order = '';
          hasChanges = true;
        }

        // Update cart if there are changes
        if (hasChanges) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ attributes }),
          })
            .then((response) => response.json())

            .catch((error) => {
              console.error('Error updating cart:', error);
            });
        }
      });
  }

  // Intercept fetch requests to cart endpoints
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = args[0];

    return originalFetch.apply(this, args).then((response) => {
      // Check if this is a cart-related endpoint
      if (
        typeof url === 'string' &&
        (url.includes('/cart/add') ||
          url.includes('/cart/update') ||
          url.includes('/cart/change'))
      ) {
        // Wait for cart to be updated, then sync attributes
        setTimeout(updateCartAttributes, 500);
      }
      return response;
    });
  };

  // Run when cart is updated - try multiple events
  document.addEventListener('theme:cart:update', () => {
    setTimeout(updateCartAttributes, 100);
  });

  document.addEventListener('cart:refresh', () => {
    setTimeout(updateCartAttributes, 100);
  });

  document.addEventListener('cart:updated', () => {
    setTimeout(updateCartAttributes, 100);
  });

  document.addEventListener('submit', (e) => {
    if (e.target.matches('[action*="/cart/add"]')) {
      setTimeout(updateCartAttributes, 500);
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
